import PropTypes from 'prop-types';
import {
  CONTENT_TYPES,
  INSTAGRAM_CONTENT_TYPES,
  MEDIA_TYPES,
  SOCIAL_PLATFORMS,
} from '~/constants';
import { ValueOf } from '~/types';

import { AssetType, assetType } from './asset';
import { LocationType } from './location';

interface IdType {
  id: string;
}

export interface ContentType {
  id: string;
  creator: IdType;
  insight: IdType;
  assets: AssetType[];
  channel: INSTAGRAM_CONTENT_TYPES;
  type: MEDIA_TYPES;
  permalink: string;
  caption: string;
  hashtags: string[];
  location: LocationType[];
  postedAt: string;
}

export type ContentNameType = ValueOf<typeof CONTENT_TYPES>;

export interface SelectContentModalTypes {
  cancelButtonText?: string;
  confirmButtonText?: string;
  disabledItemIds?: string[];
  fetchContentFn?: () => Promise<any>;
  fetchInitialContentFn?: () => any;
  headerText?: React.ReactNode;
  initialSelectedItemIds?: string[];
  isOpen?: boolean;
  maxItems?: number;
  minItems?: number;
  onCancel?: () => void;
  onClose: () => void;
  onSubmit: (
    selectedContent: any[],
    selectedContentType: ContentNameType,
    platform: SOCIAL_PLATFORMS,
  ) => void;
  shouldShowSelectionPreview?: boolean;
}
export const contentType = PropTypes.shape({
  id: PropTypes.string,
  creator: PropTypes.shape({ id: PropTypes.string }),
  insight: PropTypes.shape({ id: PropTypes.string }),
  assets: PropTypes.arrayOf(assetType),
  channel: PropTypes.oneOf(Object.keys(INSTAGRAM_CONTENT_TYPES)),
  type: PropTypes.oneOf(Object.keys(MEDIA_TYPES)),
  permalink: PropTypes.string,
  caption: PropTypes.string,
  hashtags: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.arrayOf(PropTypes.object),
  postedAt: PropTypes.string,
  contentId: PropTypes.string,
  exits: PropTypes.number,
  impressions: PropTypes.number,
  reach: PropTypes.number,
  replies: PropTypes.number,
  tapsForward: PropTypes.number,
  tapsBack: PropTypes.number,
  saved: PropTypes.number,
  videoViews: PropTypes.number,
  likes: PropTypes.number,
  comments: PropTypes.number,
  benchmarks: PropTypes.shape({
    engagementRate: PropTypes.number,
  }),
  updatedAt: PropTypes.string,
  isPasswordProtected: PropTypes.bool,
  shares: PropTypes.number,
});

export const selectContentModalTypes = {
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  disabledItemIds: PropTypes.arrayOf(PropTypes.string),
  fetchContentFn: PropTypes.func,
  fetchInitialContentFn: PropTypes.func,
  headerText: PropTypes.node,
  initialSelectedItemIds: PropTypes.arrayOf(PropTypes.string),
  isOpen: PropTypes.bool,
  maxItems: PropTypes.number,
  minItems: PropTypes.number,
  onCancel: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  shouldShowSelectionPreview: PropTypes.bool,
};
